export default __webpack_public_path__ + "static/media/quickoffer.6ee3ded1.svg";